export default {
  cms: "CMS",
  addCMS: "AddCMS",
  editCMS: "EditCMS",
};
